import { render, staticRenderFns } from "./commitOrCloseDialog.vue?vue&type=template&id=18368f54&scoped=true"
import script from "./commitOrCloseDialog.vue?vue&type=script&lang=js"
export * from "./commitOrCloseDialog.vue?vue&type=script&lang=js"
import style0 from "./commitOrCloseDialog.vue?vue&type=style&index=0&id=18368f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18368f54",
  null
  
)

export default component.exports